<template>
  <div @dragenter="handleDragEnter" @dragleave="handleDragLeave" @drop="handleDrop" @dragover="handleDragOver">
    <Header>
      <template v-slot:nav>
        <ul class='navLinks'>
          <li class='linkItem'>
            <FileUpload ref="fileUploadInstance" :on-success="handleUpload" :memory="memory">
            <span class='link'>通用抠图</span>
            </FileUpload>
          </li>
          <li class='linkItem'>
            <router-link class='link' to='/edit-goods'>批量抠商品</router-link>
          </li>
          <li class='linkItem'>
            <router-link class='link' to='/edit-people'>批量抠人像</router-link>
          </li>
          <li class='linkItem'>
            <FileUpload :on-success="handleUploadIDPhoto" :memory="memory">
              <span class='link'>证件照换底色</span>
            </FileUpload>
          </li>
        </ul>
      </template>
    </Header>
    <div class="banner">
      <div class="bannerContainer">
        <div class="title_box">
          <img src="@/assets/img/title.svg" alt="" class="title" />
          <div class="subtitle">自动识别人像、商品、图形印章，快速去除背景，一键生成证件照</div>
        </div>
        <div class="content_box">
          <div class="videoBox">
            <video
              src="https://res.yunkun.cn/pdf_geshicn/banner_pdf.mp4"
              autoplay
              loop
              muted="muted"
              width="510"
              height="325"
            ></video>
          </div>
          <FileUpload ref="fileUploadInstance" :on-success="handleUpload" :drag="true" :memory="memory">
            <div class="upload_content">
              <span class="upload_icon"></span>
              <button class="btn">上传图片</button>
              <div class="tips">请上传{{ memory / 1024 / 1024 }}M以内的JPG、JPEG、PNG、BMP、WEBP、GIF格式图片</div>
              <div class="tips2">支持拖拽上传</div>
            </div>
          </FileUpload>
        </div>
      </div>
    </div>
    <div class="linkCardBox">
      <div class="linkCardBoxContainer">
        <div class="linkCard" @click="jumpTo('/edit-goods')">
          <div class="titleBox">
            <div class="title">批量抠商品</div>
            <div class="subtitle">电商抠图神器</div>
          </div>
          <div class="button">
            <div class="txt">立即使用</div>
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.64645 0.646447C5.84171 0.451184 6.15829 0.451184 6.35355 0.646447L9.35355 3.64645C9.49655 3.78945 9.53933 4.0045 9.46194 4.19134C9.38455 4.37818 9.20223 4.5 9 4.5H1C0.723858 4.5 0.5 4.27614 0.5 4C0.5 3.72386 0.723858 3.5 1 3.5H7.79289L5.64645 1.35355C5.45118 1.15829 5.45118 0.841709 5.64645 0.646447Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </div>
          <div class="bg"></div>
        </div>
        <div class="linkCard" @click="jumpTo('/edit-people')">
          <div class="titleBox">
            <div class="title">批量抠人像</div>
            <div class="subtitle">十倍速提升你的效率</div>
          </div>
          <div class="button">
            <div class="txt">立即使用</div>
            <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.64645 0.646447C5.84171 0.451184 6.15829 0.451184 6.35355 0.646447L9.35355 3.64645C9.49655 3.78945 9.53933 4.0045 9.46194 4.19134C9.38455 4.37818 9.20223 4.5 9 4.5H1C0.723858 4.5 0.5 4.27614 0.5 4C0.5 3.72386 0.723858 3.5 1 3.5H7.79289L5.64645 1.35355C5.45118 1.15829 5.45118 0.841709 5.64645 0.646447Z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </div>
          <div class="bg"></div>
        </div>

        <div class="linkCard uploadLinkCard">
          <FileUpload :on-success="handleUploadIDPhoto" :memory="memory" class='uploadCard'>

            <div class='uploadCard'>
              <div class="titleBox">
                <div class="title">证件照换底色</div>
                <div class="subtitle">在线照相馆，专业快捷</div>
              </div>

              <div class="button">
                <div class="txt">立即使用</div>
                <span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" fill="none">
                <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.64645 0.646447C5.84171 0.451184 6.15829 0.451184 6.35355 0.646447L9.35355 3.64645C9.49655 3.78945 9.53933 4.0045 9.46194 4.19134C9.38455 4.37818 9.20223 4.5 9 4.5H1C0.723858 4.5 0.5 4.27614 0.5 4C0.5 3.72386 0.723858 3.5 1 3.5H7.79289L5.64645 1.35355C5.45118 1.15829 5.45118 0.841709 5.64645 0.646447Z"
                        fill="currentColor"
                />
              </svg>
            </span>
              </div>

              <div class="bg"></div>
            </div>

          </FileUpload>

        </div>

      </div>
    </div>
    <div class="featureArea">
      <div class="featureContainer">
        <div class="title_box">
          <div class="title">全品类 AI <span class='weight'>智能抠图</span></div>
          <div class="subtitle">轻松搞定人像、商品、动物、植物、图形</div>
        </div>
        <div class="featureBox">
          <div class="featureList">
            <div :class="{ feature: true, active: currentFeatureIndex === 0 }" @mouseenter="handleHoverFeature(0)">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M5.36763 7.68847L5.1325 8.24047C4.64817 8.03417 4.19561 7.73598 3.77398 7.35506C3.76445 7.34645 3.75494 7.33776 3.74546 7.32899C3.76476 7.46494 3.78769 7.57379 3.81231 7.65858C3.8571 7.81285 3.89448 7.90701 3.91995 7.95714M5.36763 7.68847L3.91995 7.95714M5.36763 7.68847L5.1325 8.24047C5.58609 8.43368 6.0465 8.57503 6.51328 8.66285C6.8977 8.73517 7.27393 8.84369 7.6424 8.98874C7.97791 9.12081 8.30641 9.31955 8.6276 9.59278C8.90719 9.83062 9.19344 10.2167 9.46897 10.7918C9.62461 11.1317 9.72852 11.4509 9.78618 11.75L10.3753 11.6365L9.78618 11.75C9.85174 12.0902 9.90202 12.4167 9.93736 12.7298C9.9769 13.08 10.0332 13.4167 10.1068 13.7394C10.192 14.1129 10.3459 14.4655 10.5622 14.7957C10.7894 15.1426 11.101 15.454 11.4776 15.7354L11.8367 15.2548L11.4776 15.7354C11.8209 15.9919 12.2572 16.2197 12.7708 16.4253M5.36763 7.68847L12.7708 16.4253M3.91995 7.95714C3.98301 8.08126 4.05841 8.26102 4.05948 8.46272M3.91995 7.95714L4.05948 8.46272M4.05948 8.46272C4.05949 8.46417 4.05949 8.46563 4.05949 8.46708C4.05949 8.46343 4.05936 8.4615 4.05936 8.4615C4.05937 8.4615 4.0594 8.4619 4.05948 8.46272ZM4.05948 8.46272C4.05966 8.46447 4.0601 8.46812 4.06103 8.47385C4.06327 8.48763 4.06768 8.50904 4.07584 8.53916C4.1073 8.65525 4.1331 8.78029 4.15431 8.91248C4.18197 9.08487 4.18502 9.26108 4.16865 9.43829C4.14915 9.64931 4.09027 9.85093 3.99441 10.0396C3.81908 10.3847 3.57061 10.693 3.26278 10.9671C3.12546 11.0893 2.98915 11.2057 2.85383 11.316M4.05948 8.46272L3.38503 8.22892C3.43467 8.32662 3.45949 8.40601 3.45949 8.46708C3.45949 8.52815 3.47191 8.60448 3.49673 8.69608C3.52155 8.78769 3.54327 8.8915 3.56188 9.00753C3.5805 9.12356 3.5836 9.24875 3.57119 9.3831C3.55878 9.51745 3.52155 9.64569 3.45949 9.76782C3.32298 10.0365 3.12441 10.2869 2.86378 10.519C2.60316 10.751 2.34874 10.9586 2.10053 11.1418M2.85383 11.316C2.80421 11.2872 2.75591 11.2573 2.7089 11.2264C2.59352 11.1507 2.54113 11.0965 2.52189 11.0713C2.56174 11.1236 2.62206 11.2439 2.59219 11.4007C2.59186 11.4024 2.59152 11.4042 2.59117 11.4059C2.57805 11.4705 2.55318 11.5183 2.5334 11.548C2.51383 11.5773 2.4975 11.5918 2.49557 11.5934L2.47988 11.5755L2.23204 11.2922L2.10053 11.1418M2.85383 11.316C2.72053 11.4248 2.5882 11.5276 2.45683 11.6246L2.45198 11.618L2.21889 11.3022L2.10053 11.1418M2.85383 11.316C2.93604 11.3639 3.02185 11.4091 3.11139 11.4515C3.28323 11.533 3.43562 11.6116 3.54662 11.6844L3.56609 11.6972L3.58451 11.7115C3.83993 11.909 4.03446 12.1617 4.14493 12.4681C4.23747 12.7247 4.28289 12.9922 4.28289 13.267C4.28289 13.5046 4.26513 13.7376 4.22892 13.9657C4.20637 14.1077 4.18536 14.2375 4.16593 14.3547M2.10053 11.1418C1.98883 11.2396 1.97021 11.3373 2.04468 11.435C2.11914 11.5327 2.23084 11.6304 2.37977 11.7281C2.52869 11.8258 2.68693 11.9144 2.85447 11.9937C3.02202 12.0731 3.14302 12.1373 3.21749 12.1861C3.39124 12.3205 3.51224 12.4823 3.5805 12.6716C3.64876 12.8609 3.68289 13.0594 3.68289 13.267C3.68289 13.4746 3.66737 13.6762 3.63635 13.8716C3.60532 14.067 3.5774 14.238 3.55257 14.3846C3.51534 14.5678 3.55568 14.7021 3.67358 14.7876C3.79148 14.8731 3.94972 14.9311 4.14829 14.9616C4.34686 14.9922 4.56094 14.9983 4.79054 14.98C5.02014 14.9616 5.24043 14.9342 5.45141 14.8975C5.63757 14.8731 5.88268 14.809 6.18674 14.7052C6.4908 14.6013 6.79486 14.5281 7.09892 14.4853C7.40298 14.4426 7.66981 14.4639 7.89941 14.5494C8.12901 14.6349 8.25622 14.8548 8.28104 15.209C8.29345 15.3922 8.30276 15.5693 8.30896 15.7403M4.16593 14.3547C4.07962 14.335 4.03942 14.3117 4.0258 14.3019C4.04427 14.3153 4.06632 14.3355 4.08667 14.3638C4.10718 14.3923 4.12119 14.4223 4.12956 14.4502C4.13341 14.463 4.13576 14.4742 4.13716 14.4836C4.13842 14.4919 4.13893 14.4987 4.1391 14.5037C4.13932 14.5104 4.13894 14.514 4.13891 14.5141C4.13888 14.5141 4.13917 14.5109 4.14055 14.504L4.14251 14.4944L4.14415 14.4847C4.15118 14.4432 4.15844 14.3999 4.16593 14.3547ZM4.16593 14.3547C4.18747 14.3596 4.21188 14.3644 4.23948 14.3686C4.38598 14.3911 4.55296 14.397 4.74281 14.3819C4.95537 14.3649 5.15726 14.3396 5.34874 14.3064L5.361 14.3042L5.37335 14.3026C5.50201 14.2857 5.70394 14.236 5.99287 14.1373C6.33114 14.0218 6.6721 13.9394 7.01539 13.8912C7.39366 13.838 7.76495 13.8591 8.10879 13.9872C8.65398 14.1902 8.84681 14.6996 8.87957 15.167L8.87967 15.1684C8.89247 15.3574 8.90212 15.5408 8.90857 15.7185L8.30896 15.7403M8.30896 15.7403L8.90857 15.7185C8.91559 15.9119 8.91197 16.1125 8.89837 16.32C8.88357 16.5457 8.84714 16.7817 8.79184 17.0266C8.77846 17.0859 8.76333 17.146 8.74653 17.2069M8.30896 15.7403C8.31517 15.9112 8.31207 16.0914 8.29965 16.2807C8.28724 16.47 8.25622 16.6746 8.20657 16.8944C8.19441 16.9483 8.18038 17.0036 8.16449 17.0605C8.35904 17.1162 8.55305 17.165 8.74653 17.2069M8.74653 17.2069C9.44655 17.3586 10.1397 17.4205 10.8271 17.3941C11.5028 17.3682 12.2268 17.281 12.9998 17.1307M8.74653 17.2069C8.69597 17.3902 8.63023 17.5809 8.55104 17.7782C9.32132 17.9511 10.0877 18.0229 10.85 17.9937C11.6171 17.9642 12.4362 17.8601 13.3073 17.6811C13.2055 17.5404 13.1186 17.3947 13.0499 17.2439C13.0325 17.2058 13.0158 17.1681 12.9998 17.1307M12.9998 17.1307C12.9338 16.9763 12.8796 16.8283 12.8408 16.6883C12.8149 16.5946 12.7915 16.5069 12.7708 16.4253M12.9998 17.1307C13.1822 17.0953 13.3672 17.0563 13.555 17.0138C13.5699 17.0105 13.5848 17.0071 13.5998 17.0036C13.5985 17.0008 13.5972 16.998 13.5959 16.9952C13.5152 16.8181 13.4563 16.6624 13.4191 16.528C13.3818 16.3937 13.3508 16.2746 13.326 16.1708L12.7708 16.4253M14.3721 14.419L14.3535 14.4361L14.3363 14.4548C14.2267 14.5741 14.0835 14.6456 13.8472 14.6456C13.6987 14.6456 13.5602 14.6047 13.4191 14.5098L13.412 14.505L13.4047 14.5004C12.9275 14.1984 12.6297 13.9103 12.4637 13.6499C12.2641 13.3367 12.1222 13.019 12.0337 12.6961C11.9366 12.3421 11.8681 11.9824 11.8281 11.617C11.7796 11.1737 11.6794 10.7332 11.5291 10.2963C11.3684 9.82901 11.1145 9.37371 10.7799 8.93015C10.419 8.45182 9.89516 8.0042 9.2408 7.57918L9.24084 7.57913L9.23374 7.57466C8.89571 7.36175 8.56453 7.19346 8.24119 7.07775C7.95695 6.97603 7.67237 6.88372 7.38745 6.80088C7.12467 6.72448 6.86833 6.64233 6.61839 6.55448C6.41414 6.48269 6.18551 6.3673 5.93196 6.19914C5.68984 6.03856 5.42739 5.81773 5.1454 5.52889C4.9445 5.32311 4.72824 5.05931 4.49724 4.73306C4.71606 4.47217 4.96189 4.23465 5.23532 4.02015C5.62961 3.71086 6.04857 3.45012 6.49267 3.2372C6.9376 3.02389 7.39184 2.86486 7.85595 2.75903C8.32442 2.6522 8.77606 2.6 9.21184 2.6C10.2439 2.6 11.2035 2.78225 12.0961 3.14262C12.9989 3.50712 13.7786 4.00215 14.4411 4.62609C15.1031 5.24944 15.6254 5.98191 16.0095 6.82806C16.3888 7.66367 16.5795 8.55591 16.5795 9.51134C16.5795 10.4774 16.3832 11.3735 15.9937 12.2068C15.5987 13.0519 15.0591 13.7881 14.3721 14.419Z"
                  stroke="currentColor"
                  stroke-width="1.2"
                />
              </svg>
              <span>人像</span>
            </div>
            <div :class="{ feature: true, active: currentFeatureIndex === 1 }" @mouseenter="handleHoverFeature(1)">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.08912 4.29712C4.43701 3.22557 5.43544 2.5 6.56204 2.5H13.2965C14.4231 2.5 15.4216 3.22557 15.7695 4.29711L17.2315 8.80029C17.3157 9.0596 17.3586 9.33054 17.3586 9.60317V14.7106C17.3586 16.1465 16.1945 17.3106 14.7586 17.3106H5.1C3.66406 17.3106 2.5 16.1465 2.5 14.7106V9.60317C2.5 9.33054 2.54288 9.0596 2.62707 8.80029L4.08912 4.29712ZM6.56204 3.7C5.95541 3.7 5.4178 4.09069 5.23047 4.66768L3.85869 8.89283H6.10527C6.89735 8.89283 7.57022 9.47239 7.6876 10.2557L7.83404 11.233C7.86338 11.4288 8.0316 11.5737 8.22962 11.5737H11.629C11.827 11.5737 11.9952 11.4288 12.0245 11.233L12.171 10.2557C12.2884 9.47238 12.9612 8.89283 13.7533 8.89283H15.9999L14.6281 4.66768C14.4408 4.09069 13.9032 3.7 13.2965 3.7H6.56204ZM3.7 14.7106V10.0928H6.10527C6.30329 10.0928 6.4715 10.2377 6.50085 10.4336L6.64729 11.4108C6.76467 12.1942 7.43754 12.7737 8.22962 12.7737H11.629C12.421 12.7737 13.0939 12.1942 13.2113 11.4108L13.3577 10.4336C13.3871 10.2377 13.5553 10.0928 13.7533 10.0928H16.1586V14.7106C16.1586 15.4838 15.5318 16.1106 14.7586 16.1106H5.1C4.3268 16.1106 3.7 15.4838 3.7 14.7106ZM10.624 5.86019C10.2403 5.86019 9.92925 6.17122 9.92925 6.55489C9.92925 6.93857 10.2403 7.24959 10.6239 7.24959H13.2889C13.6726 7.24959 13.9836 6.93857 13.9836 6.55489C13.9836 6.17122 13.6726 5.86019 13.2889 5.86019H10.624Z"
                  fill="currentColor"
                  fill-opacity="0.8"
                />
              </svg>
              <span>商品</span>
            </div>
            <div :class="{ feature: true, active: currentFeatureIndex === 2 }" @mouseenter="handleHoverFeature(2)">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.9085 3.46725C12.8928 3.46444 12.878 3.46306 12.8631 3.46306L12.8631 3.46304C12.732 3.46304 12.5502 3.57891 12.3765 3.77297C12.1177 4.06224 11.8998 4.49847 11.7786 4.96981C11.6367 5.52257 11.65 6.00914 11.8143 6.27108L11.8143 6.27109C11.8499 6.32791 11.9584 6.50077 12.3712 6.57502C12.4906 6.59657 12.5997 6.60742 12.6963 6.60742C13.0009 6.60742 13.0805 6.50379 13.1332 6.43521C13.2277 6.31228 13.3968 5.99694 13.4675 5.26623C13.5479 4.43367 13.3985 3.98678 13.3022 3.79449C13.1783 3.54692 13.0398 3.4909 12.9085 3.46725ZM7.42047 3.84241C7.31039 3.71496 7.14536 3.56307 6.98445 3.56307H6.98432C6.96764 3.56313 6.95099 3.56439 6.93448 3.56681L6.93447 3.56681C6.88172 3.57441 6.74138 3.59464 6.57893 3.9111C6.40409 4.25169 6.30381 4.76896 6.30381 5.33035C6.30381 5.73544 6.3945 6.08503 6.55262 6.28946C6.63667 6.39814 6.77606 6.52287 7.11063 6.52287C7.18159 6.52287 7.25812 6.51703 7.33809 6.50552C7.65797 6.45966 7.87376 6.35248 7.98025 6.18684C8.12749 5.95778 8.13979 5.54099 8.01315 5.07192C7.87526 4.56197 7.66473 4.12513 7.42047 3.84241ZM16.8678 8.12538C16.8175 8.10053 16.7655 8.08905 16.7038 8.08905C16.4222 8.08905 16.0558 8.31985 15.8128 8.65032C15.7062 8.79535 15.6617 8.94934 15.6877 9.08357C15.7261 9.28118 15.9171 9.43356 16.0705 9.52658L16.0891 9.53787C16.2014 9.60338 16.301 9.6379 16.378 9.6379C16.5468 9.6379 16.7704 9.42691 16.9344 9.11286C17.0515 8.88882 17.0783 8.57645 17.0013 8.33511C16.9677 8.22983 16.9166 8.14947 16.8678 8.12538ZM3.96169 8.70878C3.75809 8.51772 3.52199 8.41261 3.29669 8.41261L3.29664 8.41263C3.14896 8.41263 3.01387 8.45959 2.93533 8.53823C2.9213 8.55363 2.86756 8.6649 2.88449 8.88768C2.90432 9.14858 3.01258 9.42774 3.17408 9.63439C3.29795 9.79289 3.46569 9.88377 3.63437 9.88377C3.7831 9.88377 3.92761 9.81317 4.06389 9.67394C4.15099 9.58496 4.29659 9.41184 4.29325 9.25209C4.2901 9.10146 4.16925 8.90342 3.96169 8.70878ZM10.6039 4.65463C10.9485 3.31419 11.8428 2.22221 12.863 2.22217C12.949 2.2222 13.0348 2.22991 13.1194 2.24522C14.2439 2.44784 14.8471 3.61961 14.6761 5.38823C14.5257 6.94398 13.9192 7.84834 12.6963 7.84834C12.5293 7.84834 12.3509 7.83149 12.1606 7.79713C10.5766 7.51219 10.2312 6.10585 10.6039 4.65463ZM6.76517 2.33804C6.83922 2.32739 6.91239 2.32218 6.98434 2.32218C8.01099 2.3221 8.81562 3.37971 9.18399 4.74194C9.57768 6.20016 9.10241 7.50567 7.50762 7.73423C7.36954 7.75412 7.23713 7.76374 7.11065 7.76374C5.77666 7.76374 5.08929 6.69508 5.08929 5.33033C5.08929 3.83568 5.63488 2.50073 6.76517 2.33804ZM14.8417 7.90493C15.299 7.28311 16.0085 6.84818 16.7037 6.84816C16.9397 6.84814 17.174 6.89824 17.3963 7.00814C18.2746 7.44181 18.4914 8.76828 18.0059 9.69701C17.6611 10.3572 17.0874 10.8788 16.378 10.8788C16.0894 10.8788 15.7785 10.7926 15.4513 10.5943L15.4508 10.5938C14.3196 9.90812 14.2297 8.73784 14.8417 7.90493ZM2.0853 7.65191C2.39241 7.34444 2.82778 7.17174 3.29662 7.17172C3.79192 7.1717 4.32456 7.36445 4.78301 7.79463C5.67589 8.63202 5.76871 9.68701 4.9227 10.5514C4.53779 10.9447 4.08044 11.1247 3.63439 11.1247C3.10068 11.1247 2.58313 10.867 2.22499 10.4086C1.56705 9.56676 1.45324 8.2847 2.0853 7.65191ZM12.0387 10.4271C11.3872 9.87557 10.7875 9.59592 10.2561 9.59592H10.2559L10.2418 9.59598L10.2377 9.59602C9.69131 9.60212 9.06893 9.9019 8.38761 10.487C7.57654 11.1836 6.70573 12.2676 5.79938 13.7089C5.35322 14.4184 5.46993 15.348 6.07684 15.9194L6.39872 16.2228C6.61362 16.4252 6.89355 16.5368 7.1866 16.5368C7.426 16.5368 7.65634 16.4626 7.85274 16.322L8.02211 16.2007L8.0226 16.2003L8.02311 16.2C8.64081 15.7585 9.36572 15.5251 10.1195 15.5251C10.8705 15.5252 11.5932 15.757 12.2094 16.1955L12.3188 16.2733C12.5119 16.4107 12.7385 16.4834 12.9737 16.4834C13.2499 16.4834 13.5168 16.3817 13.7256 16.1968L13.7259 16.1965L13.7263 16.1962L14.1836 15.7917C14.4993 15.512 14.7058 15.1256 14.7656 14.7031C14.8253 14.2806 14.7342 13.8502 14.5089 13.4907C13.6481 12.1168 12.817 11.0861 12.0387 10.4271ZM10.2311 8.35514L10.2559 8.35503C11.9076 8.35493 13.6659 9.84363 15.5318 12.8216C16.3226 14.0837 16.0874 15.7474 14.9794 16.7292L14.5212 17.1344C14.0795 17.5257 13.5276 17.7243 12.9737 17.7243C12.5035 17.7243 12.0319 17.5813 11.6247 17.2916L11.5153 17.2138C11.0958 16.9153 10.6076 16.7661 10.1194 16.7661C9.61851 16.7658 9.12968 16.9232 8.71937 17.2168L8.54939 17.3385C8.138 17.6328 7.66128 17.7777 7.1866 17.7777C6.60546 17.7777 6.02729 17.5607 5.5752 17.1349L5.2538 16.832C4.21438 15.8534 4.0135 14.2532 4.77757 13.0382C6.73137 9.93113 8.5489 8.37011 10.2306 8.35514H10.2311ZM11.0721 12.2821C11.1317 12.3072 11.1958 12.32 11.2604 12.3199C11.3877 12.3201 11.5099 12.2702 11.6007 12.181C11.7924 11.993 11.7954 11.6852 11.6075 11.4935L11.016 10.8903C10.8281 10.6986 10.5203 10.6955 10.3286 10.8835C10.1369 11.0715 10.1339 11.3792 10.3218 11.5709L10.9133 12.1742C10.9585 12.2204 11.0125 12.2571 11.0721 12.2821ZM13.6516 14.8608C13.7108 14.8855 13.7743 14.8981 13.8385 14.898C13.9668 14.8982 14.09 14.8474 14.181 14.7568C14.3715 14.5677 14.3725 14.2599 14.1834 14.0694L12.4943 12.3685C12.3051 12.178 11.9974 12.1769 11.8069 12.3661C11.6164 12.5553 11.6153 12.8631 11.8045 13.0535L13.4935 14.7544C13.5387 14.8 13.5924 14.8362 13.6516 14.8608Z"
                  fill="currentColor"
                  fill-opacity="0.8"
                />
              </svg>
              <span>动物</span>
            </div>
            <div :class="{ feature: true, active: currentFeatureIndex === 3 }" @mouseenter="handleHoverFeature(3)">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.9653 14.4961C16.9265 14.5293 16.8861 14.558 16.8442 14.5822C16.546 14.9009 15.9856 15.3991 15.0985 15.8263C13.9513 16.3752 13.086 16.6546 11.5481 16.6546C11.4075 16.6546 11.3934 16.6507 11.3726 16.6449C11.3528 16.6394 11.3268 16.6321 11.1797 16.6249L11.1327 16.6224C10.9568 16.6127 10.8044 16.5347 10.6977 16.415V17.7893C10.6977 18.0885 10.4529 18.3332 10.1537 18.3332C10.0822 18.3334 10.0114 18.3195 9.94533 18.2922C9.87925 18.265 9.8192 18.2249 9.76865 18.1744C9.7181 18.1238 9.67804 18.0638 9.65078 17.9977C9.62352 17.9316 9.60959 17.8608 9.6098 17.7893V10.6511C9.58081 10.6355 9.55213 10.616 9.52323 10.5922L7.973 9.32882C7.7678 9.17059 7.73565 8.86895 7.90872 8.66374C8.06695 8.45854 8.3686 8.42638 8.5738 8.59945L9.6098 9.44543V6.62625C9.6098 6.32462 9.8521 6.08232 10.1537 6.08232C10.4554 6.08232 10.6977 6.32462 10.6977 6.62625V7.41509L10.9127 7.25446C11.1179 7.09623 11.4196 7.14319 11.5778 7.34841C11.736 7.55363 11.6891 7.85525 11.4839 8.0135L10.6977 8.6007V11.7426L12.0896 10.8766C12.3121 10.7332 12.6113 10.8123 12.7374 11.0348C12.8808 11.2573 12.8017 11.5565 12.5791 11.6826L10.9498 12.6963C10.8855 12.7309 10.7916 12.7606 10.7125 12.7606L10.6977 12.7603V15.5566C10.8223 15.4192 11.0078 15.3389 11.2143 15.3516C11.2804 15.3559 11.2716 15.3606 11.2642 15.3646C11.2543 15.3699 11.2469 15.3739 11.4171 15.3739C12.7275 15.3739 14.6362 15.1464 16.0133 13.616C16.0385 13.5888 16.0659 13.5639 16.0952 13.5416C16.3452 13.24 16.4633 12.9228 16.4633 12.5527C16.4633 11.6825 15.7537 10.9729 14.8835 10.9729C14.8315 10.9729 14.6684 10.9877 14.5991 11.0025L14.5892 11.005C14.562 11.0075 14.5348 11.0099 14.5076 11.0099C14.2085 11.0099 13.9489 10.8023 13.8895 10.5179C13.8104 10.2113 13.986 9.88499 14.2925 9.77621C14.9304 9.55864 15.3557 8.95782 15.3557 8.28285C15.3557 7.41256 14.6461 6.70297 13.7758 6.70297C13.3258 6.70297 12.9277 6.87604 12.6286 7.20488C12.5099 7.33591 12.3418 7.41009 12.1687 7.41009C12.0154 7.41009 11.8696 7.35323 11.7558 7.24938C11.6347 7.14801 11.5556 6.99473 11.5407 6.83154C11.5234 6.66589 11.5729 6.50271 11.6742 6.37909C11.9331 6.0432 12.0846 5.6592 12.1207 5.2591C12.1053 5.20351 12.097 5.14463 12.097 5.08349C12.097 3.90663 11.1402 2.94979 9.96332 2.94979C8.78645 2.94979 7.82961 3.90663 7.82961 5.08351C7.82961 5.55821 7.98291 5.9983 8.28701 6.3939C8.38838 6.5274 8.43535 6.69305 8.41558 6.86118C8.39579 7.03179 8.31174 7.18012 8.17823 7.28397C8.06944 7.3705 7.94088 7.41254 7.79501 7.41254C7.60462 7.41254 7.41672 7.326 7.2931 7.1826L7.29064 7.17767C6.81097 6.58427 6.55878 5.85985 6.55878 5.08351C6.55878 3.24143 8.03107 1.73528 9.86016 1.68051C9.90366 1.67141 9.94891 1.66663 9.99548 1.66663C11.872 1.66663 13.4 3.19459 13.4 5.07116C13.4 5.20716 13.3926 5.33818 13.3802 5.47417C13.5088 5.45687 13.6423 5.44698 13.7931 5.44698C15.3656 5.44698 16.6438 6.72522 16.6438 8.29768C16.6438 8.90839 16.4535 9.48692 16.09 9.98636C16.545 10.194 16.9356 10.5179 17.2273 10.9283C17.5685 11.408 17.749 11.9767 17.749 12.5701C17.749 13.2772 17.4894 13.92 16.9801 14.4812L16.9727 14.4887L16.9653 14.4961ZM3.93042 13.624L3.9232 13.6159C3.62899 13.2895 3.49053 12.9533 3.49053 12.5527C3.49053 11.6824 4.20011 10.9728 5.07042 10.9728C5.11985 10.9728 5.2682 10.9877 5.35969 11.0025H5.36462C5.39182 11.005 5.41902 11.0075 5.44622 11.0075C5.73302 11.0075 5.98769 10.8072 6.06433 10.5204C6.15086 10.2014 5.97779 9.88002 5.66132 9.7737C5.0259 9.55613 4.59817 8.9578 4.59817 8.28036C4.59817 7.52379 5.13717 6.87355 5.87642 6.73015C6.21514 6.66587 6.44756 6.32713 6.38326 5.98841C6.32641 5.69171 6.05691 5.46921 5.75527 5.46921C5.71817 5.46921 5.67862 5.47168 5.64154 5.47909C4.99377 5.60273 4.40286 5.95133 3.98006 6.4656C3.55974 6.97739 3.32734 7.62269 3.32734 8.28036C3.32734 8.89353 3.52266 9.48443 3.87869 9.96904C3.42624 10.1792 3.03559 10.5006 2.74385 10.911C2.40265 11.3907 2.22217 11.9593 2.22217 12.5527C2.22217 13.2615 2.4707 13.8922 2.95852 14.4286C2.96808 14.4408 2.97811 14.4526 2.98861 14.464C4.32125 15.9598 6.31154 16.4444 7.74555 16.5903H7.80985C8.14115 16.5903 8.40817 16.343 8.42796 16.0142C8.44774 15.6631 8.20295 15.364 7.8593 15.3219H7.85684C6.65054 15.1986 4.99386 14.8021 3.93042 13.624Z"
                  fill="currentColor"
                  fill-opacity="0.8"
                />
              </svg>
              <span>植物</span>
            </div>
            <div :class="{ feature: true, active: currentFeatureIndex === 4 }" @mouseenter="handleHoverFeature(4)">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.78285 2.8211C9.48909 1.90113 10.8074 1.72786 11.7274 2.4341L15.5172 5.34345C16.4372 6.04969 16.6104 7.368 15.9042 8.28798L15.1579 9.26013C15.5571 9.4119 15.9412 9.62365 16.2974 9.89708C18.2639 11.4067 18.6343 14.2247 17.1246 16.1912C15.8022 17.9139 13.4757 18.4117 11.5972 17.4938H9.49998H7.55554H5.16665C4.00685 17.4938 3.06665 16.5536 3.06665 15.3938V10.616C3.06665 9.45624 4.00685 8.51604 5.16665 8.51604H5.38259C5.24308 7.92055 5.36531 7.27291 5.7613 6.75708L8.78285 2.8211ZM10.0832 16.2938C8.79642 14.7173 8.71035 12.4085 10.0033 10.7243C10.2403 10.4155 10.5096 10.1461 10.8028 9.91712C10.7409 9.79766 10.6161 9.71604 10.4722 9.71604H5.16665C4.6696 9.71604 4.26665 10.119 4.26665 10.616V15.3938C4.26665 15.8909 4.66959 16.2938 5.16665 16.2938H7.55554H9.49998H10.0832ZM11.8399 9.31233C12.4795 9.04704 13.1726 8.93315 13.8615 8.97826L14.9523 7.55726C15.255 7.16298 15.1808 6.59799 14.7865 6.29532L10.9967 3.38596C10.6024 3.08329 10.0374 3.15755 9.73471 3.55182L6.71317 7.4878C6.47959 7.79206 6.46827 8.20331 6.66573 8.51604H10.4722C11.0583 8.51604 11.5696 8.83678 11.8399 9.31233ZM10.9551 11.455C12.0612 10.0142 14.1259 9.74287 15.5667 10.8489C17.0075 11.955 17.2788 14.0197 16.1728 15.4605C15.0667 16.9013 13.002 17.1726 11.5612 16.0666C10.1204 14.9605 9.84907 12.8958 10.9551 11.455Z"
                  fill="currentColor"
                  fill-opacity="0.8"
                />
              </svg>
              <span>图形</span>
            </div>
          </div>
          <div class="compareBox" ref="compareBoxRef">
            <img :src="featureList[currentFeatureIndex].target" alt="" class="target_picture" />
            <div class="touchBox">
              <div class="touchContainer">
                <img :src="featureList[currentFeatureIndex].origin" class="origin_picture" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="swiperArea">
      <div class="swiperContainer">
        <div class="title_box">
          <div class="title">“抠”细节，秒抠比你更细致</div>
          <div class="subtitle">
            发丝极抠图效果，细节处理毫不含糊。支持自定义更换背景，改尺寸，手动抠图，大胆释放您的创意！
          </div>
        </div>
        <div class="carouselBox">
          <el-carousel
            ref="swiper"
            class="ttt"
            :autoplay="true"
            indicator-position="none"
            arrow="never"
            @change="onSwiperChange"
          >
            <el-carousel-item class="carouselItem">
              <img src="https://res.yunkun.cn/miaokou/img/slice_1.png" alt="" />
            </el-carousel-item>
            <el-carousel-item class="carouselItem">
              <img src="https://res.yunkun.cn/miaokou/img/slice_2.png" alt="" />
            </el-carousel-item>
            <el-carousel-item class="carouselItem">
              <img src="https://res.yunkun.cn/miaokou/img/slice_3.png" alt="" />
            </el-carousel-item>
            <el-carousel-item class="carouselItem">
              <img src="https://res.yunkun.cn/miaokou/img/slice_4.png" alt="" />
            </el-carousel-item>
            <el-carousel-item class="carouselItem">
              <img src="https://res.yunkun.cn/miaokou/img/slice_5.png" alt="" />
            </el-carousel-item>
          </el-carousel>
          <div class="pointerList">
            <span :class="{ pointer: true, active: activeIndex === 0 }" @click="handleChange(0)"></span>
            <span :class="{ pointer: true, active: activeIndex === 1 }" @click="handleChange(1)"></span>
            <span :class="{ pointer: true, active: activeIndex === 2 }" @click="handleChange(2)"></span>
            <span :class="{ pointer: true, active: activeIndex === 3 }" @click="handleChange(3)"></span>
            <span :class="{ pointer: true, active: activeIndex === 4 }" @click="handleChange(4)"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="clientEvaluationArea">
      <div class="clientEvaluationContainer">
        <div class="title_box">
          <div class="title">秒抠值得更多人信赖</div>
        </div>
        <div class="evaluationBox">
          <div class="handleBox">
            <div class="prev" @click="onClickPrev">
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="46" viewBox="0 0 50 46" fill="none">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15 23C15 22.4477 15.4477 22 16 22H34C34.5523 22 35 22.4477 35 23C35 23.5523 34.5523 24 34 24H16C15.4477 24 15 23.5523 15 23Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M25.7071 13.2929C26.0976 13.6834 26.0976 14.3166 25.7071 14.7071L17.4142 23L25.7071 31.2929C26.0976 31.6834 26.0976 32.3166 25.7071 32.7071C25.3166 33.0976 24.6834 33.0976 24.2929 32.7071L15.2929 23.7071C14.9024 23.3166 14.9024 22.6834 15.2929 22.2929L24.2929 13.2929C24.6834 12.9024 25.3166 12.9024 25.7071 13.2929Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div class="next" @click="onClickNext">
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="46" viewBox="0 0 50 46" fill="none">
                <path
                  d="M16 23H34"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M25 14L34 23L25 32"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div>
            <swiper ref="commentSwiper" :options="swiperOptions" class="my-swiper-container">
              <swiper-slide class="my-swiper-slide" v-for="(comment, idx) in commentList" :key="idx">
                <div class="cardContainer">
                  <div class="cardHeader">
                    <img :src="comment.avatar" alt="" class="avatar" />
                    <div class="userInfo">
                      <div class="userName">{{ comment.name }}</div>
                      <div class="job">{{ comment.job }}</div>
                    </div>
                  </div>
                  <div class="content">{{ comment.content }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <div class="bottomBanner">
      <img src="@/assets/img/home_bottom_banner.svg" alt="" class="bg" />
      <div class="btnGroups">
        <FileUpload :on-success="handleUpload" :memory="memory">
          <button class="upload_btn">
            <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.4418 3.74384C15.7524 3.44118 16.2476 3.44118 16.5583 3.74384L25.6759 12.6269C26.19 13.1278 25.8354 13.9999 25.1176 13.9999H19.2V21.3999C19.2 21.9522 18.7523 22.3999 18.2 22.3999H13.8C13.2477 22.3999 12.8 21.9522 12.8 21.3999V13.9999H6.88242C6.16466 13.9999 5.81005 13.1278 6.32415 12.6269L15.4418 3.74384ZM8.00002 23.9999C7.11636 23.9999 6.40002 24.7163 6.40002 25.5999C6.40002 26.4836 7.11636 27.1999 8.00002 27.1999H24C24.8837 27.1999 25.6 26.4836 25.6 25.5999C25.6 24.7163 24.8837 23.9999 24 23.9999H8.00002Z"
                fill="#1F4AF2"
              />
            </svg>
            <span>上传图片</span>
          </button>
        </FileUpload>
      </div>
    </div>

    <div class="dragMask" v-show="isDragging">
      <div class="title">松开即可上传</div>
      <div>（一次一个文件）</div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import { directive, Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import FileUpload from '@/components/FileUpload/index.vue'

const commentList = [
  {
    avatar: require('@/assets/img/user-avatar-1.png'),
    name: '刘静',
    job: '博主',
    content: '秒抠真是我的救星！操作简单，抠图效果超赞，给我的作品增色不少，省时省力，真是博主必备神器！'
  },
  {
    avatar: require('@/assets/img/user-avatar-2.png'),
    name: '李雪峰',
    job: '电商卖家',
    content:
      '秒抠帮助我优化产品展示图，去除背景干净利落，提高了商品的吸引力，简单易用，是商家宣传的得力助手，强烈推荐。'
  },
  {
    avatar: require('@/assets/img/user-avatar-3.png'),
    name: '张雅文',
    job: '设计师',
    content:
      '秒抠简洁直观的用户界面让操作变得轻松愉悦，出色的抠图效果让我在设计过程中事半功倍，轻松去除背景，可以更精细地调整抠图结果。'
  },
  {
    avatar: require('@/assets/img/user-avatar-4.png'),
    name: '林晓明',
    job: '博主',
    content: '秒抠为我的图片处理提供了极大的便利，一键去背景的操作简单易上手，效果惊艳，让我能够更专注于创作。'
  },
  {
    avatar: require('@/assets/img/user-avatar-5.png'),
    name: '韩浩然',
    job: '博主',
    content: '秒抠是小红书博主们的必备神器，高效去除背景，维持细节完整，是提升博客图片质量的不二选择，真是太方便了。'
  },
  {
    avatar: require('@/assets/img/user-avatar-6.png'),
    name: '王梦阳',
    job: '博主',
    content:
      '秒抠为我的小红书内容创作提供了便捷的图像处理方案，让我的图片更有创意，效果超赞，强烈推荐给所有小红书博主！'
  }
]
export default {
  name: 'Home',
  metaInfo() {
    return {
      title: this.tdk?.title,
      meta: [
        {
          name: 'keywords',
          content: this.tdk?.keywords
        },
        {
          name: 'description',
          content: this.tdk?.description
        }
      ]
    }
  },
  components: {
    FileUpload,
    Swiper,
    SwiperSlide,
    directive,
    Header,
    Footer
  },
  directives: {
    swiper: directive
  },
  props: {},
  data() {
    return {
      commentList,
      tdk: {},
      memory: 25 * 1024 * 1024,

      featureList: [
        {
          origin: 'https://res.yunkun.cn/miaokou/img/feature_normal_1.png',
          target: 'https://res.yunkun.cn/miaokou/img/feature_1.png'
        },
        {
          origin: 'https://res.yunkun.cn/miaokou/img/feature_normal_2.png',
          target: 'https://res.yunkun.cn/miaokou/img/feature_2.png'
        },
        {
          origin: 'https://res.yunkun.cn/miaokou/img/feature_normal_3.png',
          target: 'https://res.yunkun.cn/miaokou/img/feature_3.png'
        },
        {
          origin: 'https://res.yunkun.cn/miaokou/img/feature_normal_4.png',
          target: 'https://res.yunkun.cn/miaokou/img/feature_4.png'
        },
        {
          origin: 'https://res.yunkun.cn/miaokou/img/feature_normal_5.png',
          target: 'https://res.yunkun.cn/miaokou/img/feature_5.png'
        }
      ],
      activeIndex: 0,
      currentFeatureIndex: 0,
      isDragging: false,
      swiperOptions: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        delay: 3500,
        speed: 800,
        loop: true,
        observer: true,
        observeParents: true,
        slidesPerView: 3,
        spaceBetween: 12
      }
    }
  },
  computed: {
    commentSwiper() {
      return this.$refs.commentSwiper.$swiper
    }
  },
  methods: {
    jumpTo(path) {
      this.$router.push(path)
    },
    onSwiperChange(index) {
      this.activeIndex = index
    },
    handleChange(index) {
      this.activeIndex = index
      this.$refs.swiper.setActiveItem(index)
    },
    handleHoverFeature(index) {
      this.currentFeatureIndex = index
      document.querySelector('.touchBox').style.width = `50%`
    },
    handleDragEnter() {
      this.isDragging = true
    },
    handleDragLeave(e) {
      this.isDragging = e.clientX !== 0 || e.clientY !== 0
    },

    /**
     * @description 触发上传
     * @param file
     */
    handleUpload(params) {
      this.$router.push({
        name: 'editor',
        params: params
      })
    },
    handleUploadIDPhoto(params) {
      this.$router.push({
        name: 'edit-photo',
        params: params
      })
    },
    async handleDrop(e) {
      e.preventDefault()
      const fileList = e.dataTransfer.files
      this.isDragging = false
      await this.$refs.fileUploadInstance.handleUpload(fileList[0])
    },
    handleDragOver(e) {
      e.preventDefault()
    },
    onClickPrev() {
      this.commentSwiper.slidePrev()
    },
    onClickNext() {
      this.commentSwiper.slideNext()
    }
  },
  created() {
    this.tdk = this.$route.meta.tdk
  },
  mounted() {
    const { left: offsetLeft, width } = this.$refs.compareBoxRef.getBoundingClientRect()

    this.listener = e => {
      const disX = e.clientX - offsetLeft
      const minX = 20
      const maxX = width - 20
      document.querySelector('.touchBox').style.width = `${disX < minX ? minX : disX > maxX ? maxX : disX}px`
    }
    this.$refs.compareBoxRef.addEventListener('mousemove', this.listener)
  },
  beforeDestroy() {
    this.$refs.compareBoxRef.removeEventListener('mousemove', this.listener)
  }
}
</script>
<style scoped lang="less">
@import './index.less';
</style>
